<header class="header-area">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-2 col-sm-0">
                <div class="logo">
                    <a routerLink="/"><img src="assets/images/logo.png" alt="logo" /></a>
                </div>
            </div>

            <div class="col-lg-8 col-sm-6 text-end pr-0">
                <div class="header-content-right">
                    <ul class="header-contact">
                        <li><a href="tel:08672228322"><i class="bx bxs-phone-call"></i> 086722 28322</a></li>
                        <li><a href="mailto:sribalasaidegreecollege&#64;gmail.com"><i class="bx bxs-envelope"></i> sribalasaidegreecollege&#64;gmail.com</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-2 col-sm-6 text-end pl-0">
                <div class="header-content-right">
                    <ul class="header-social">
                        <li><a href="https://www.facebook.com/SBSDCMachilipatnam/" target="_blank"><i class="bx bxl-facebook"></i></a></li>
                        <li><a href="https://in.linkedin.com/school/sri-balasai-degree-college/" target="_blank"><i class="bx bxl-linkedin"></i></a></li>
                        <li><a href="https://www.instagram.com/sri_bala_sai_degree_college/reels/" target="_blank"> <i class="bx bxl-instagram"></i></a></li>
                        <li><a href="#" target="_blank"> <i class="bx bxl-youtube"></i></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</header>

<div class="{{navbarClass}}">
    <div class="main-nav" [ngClass]="{'sticky': isSticky}" style="background: var(--darkBlueColor) !important;">
        <div class="container">
            <nav class="navbar navbar-expand-lg navbar-light" [class.active]="classApplied">
                <a class="navbar-brand d-none" routerLink="/">
                    <img src="assets/images/logo2.png" alt="logo">
                </a>
                <button class="navbar-toggler" type="button" (click)="toggleClass()">
                    <span class="burger-menu">
                        <span class="top-bar"></span>
                        <span class="middle-bar"></span>
                        <span class="bottom-bar"></span>
                    </span>
                </button>
                <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                    <ul class="navbar-nav text-left">
                        <li class="nav-item"><a routerLink="/" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">Home</a></li>
                        <li class="nav-item"><a routerLink="/about" class="nav-link">About</a> </li>
                        <li class="nav-item"><a routerLink="/courses" class="nav-link">Courses</a></li>
                        <li class="nav-item"> <a routerLink="/admissions" class="nav-link">Admissions</a></li>
                        <li class="nav-item"><a routerLink="/placements" class="nav-link">Placements</a></li>
                        <li class="nav-item"><a routerLink="/contact" class="nav-link">Contact </a></li>
                    </ul>
                </div>
                <div class="nav-right">

                </div>
            </nav>
        </div>
    </div>
</div>